import React from "react";
import Sigil from "./Sigil";
import { Github, Twitter, Mail } from "lucide-react";

const FooterSection = () => {
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-[#030000] pt-16 pb-8 px-6 md:px-12 overflow-hidden"
    >
      {/* Ticker */}
      <div className="ticker-wrap py-3 mb-12 -mx-6 md:-mx-12">
        <div className="ticker font-rune text-[#8A0303] text-lg tracking-[0.5em]">
          ⌬ qapla' ⌬ Heghlu'meH&nbsp;QaQ&nbsp;jajvam ⌬ tlhIngan&nbsp;maH ⌬ batlh&nbsp;bIHeghjaj ⌬ bIjatlh&nbsp;'e'&nbsp;yImev ⌬ qo'mey&nbsp;poSmoH&nbsp;Hol ⌬ may'&nbsp;Duj ⌬ yIn&nbsp;ej&nbsp;tlhutlh ⌬ Qapla'! ⌬
        </div>
      </div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <Sigil size={48} />
            <div>
              <div className="font-display text-2xl text-[#E6B836] tracking-widest">
                qapla<span className="text-[#FF2A2A]">.uk</span>
              </div>
              <div className="font-mono-k text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0]">
                imperio digital · forjado por bicio
              </div>
            </div>
          </div>
          <p className="font-mono-k text-[#A0A0A0] text-sm leading-relaxed max-w-md">
            Una landing forjada en honor klingon. Si has llegado hasta aquí,
            <span className="text-[#E6B836]">&nbsp;eres bienvenido en el puente</span>.
            Si no has llegado — ya no importa.
          </p>
        </div>

        {/* Links */}
        <div className="md:col-span-3">
          <div className="font-mono-k text-[10px] uppercase tracking-[0.4em] text-[#C59B27] mb-4">
            // navegación
          </div>
          <ul className="space-y-2 font-mono-k text-sm text-[#A0A0A0]">
            <li><a href="#transmision" className="hover:text-[#E6B836] transition-colors" data-testid="footer-link-video">▸ transmisión</a></li>
            <li><a href="#apps" className="hover:text-[#E6B836] transition-colors" data-testid="footer-link-apps">▸ arsenal</a></li>
            <li><a href="#lore" className="hover:text-[#E6B836] transition-colors" data-testid="footer-link-lore">▸ código de honor</a></li>
            <li><a href="#" className="hover:text-[#E6B836] transition-colors" data-testid="footer-link-top">▸ volver al puente</a></li>
          </ul>
        </div>

        {/* Contact / Channels */}
        <div className="md:col-span-4">
          <div className="font-mono-k text-[10px] uppercase tracking-[0.4em] text-[#C59B27] mb-4">
            // canales abiertos
          </div>
          <div className="flex items-center gap-3">
            {[
              { Icon: Github, href: "#", label: "github" },
              { Icon: Twitter, href: "#", label: "x" },
              { Icon: Mail, href: "#", label: "mail" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                data-testid={`footer-social-${label}`}
                aria-label={label}
                className="w-11 h-11 flex items-center justify-center border border-[#2A0A0A] text-[#A0A0A0] hover:text-[#E6B836] hover:border-[#C59B27] hover:bg-[#100000] transition-all"
                style={{ clipPath: "polygon(20% 0, 100% 0, 100% 80%, 80% 100%, 0 100%, 0 20%)" }}
              >
                <Icon size={16} strokeWidth={1.6} />
              </a>
            ))}
          </div>

          <div className="mt-6 border border-[#2A0A0A] bg-black/40 p-4 font-mono-k text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0] panel-corner-tl panel-corner-tr relative">
            <div className="flex justify-between"><span>STARDATE</span><span className="text-[#EAEAEA]">78972.6</span></div>
            <div className="flex justify-between"><span>FLEET</span><span className="text-[#EAEAEA]">BICIO-01</span></div>
            <div className="flex justify-between"><span>STATUS</span><span className="text-[#FF2A2A]">listo&nbsp;para&nbsp;la&nbsp;batalla</span></div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-[#2A0A0A] flex flex-col md:flex-row items-center justify-between gap-3 font-mono-k text-[10px] uppercase tracking-[0.3em] text-[#555]">
        <div data-testid="footer-copy">© stardate 78972.6 · qapla.uk · todos los honores reservados</div>
        <div className="text-[#C59B27]">qapla'!&nbsp;·&nbsp;éxito</div>
      </div>
    </footer>
  );
};

export default FooterSection;
